import { AdUnitFormat } from "@store";
import { ChartDataResponse, MetricInfo, MetricLabels } from "@api/common";
import * as React from "react";
import "./AdFormatOverviewDetailsReport.css";
import { MetricSetData, MetricSetRow, MetricSetTable } from "./MetricSet";
import { formatNumber } from "@common";

export interface AdFormatOverviewDetailsReportProps {
    adUnit: AdUnitFormat;
    metrics: MetricInfo[];
    data: ChartDataResponse;
    pointerPosition: number;
}

export function AdFormatOverviewDetailsReport({
    adUnit,
    metrics,
    data,
    pointerPosition
}: AdFormatOverviewDetailsReportProps) {
    return data && adUnit ? (
        <div className="AdFormatOverviewDetailsReportContainer">
            <div className="AdFormatOverviewDetailsReport">
                <div className="AdFormatOverviewDetailsReport__format-info AdFormatOverviewDetailsReportFormatInfo">
                    <div className="AdFormatOverviewDetailsReportFormatInfo__title">{adUnit.name}</div>
                    <div className="AdFormatOverviewDetailsReportFormatInfo__size">{adUnit.size}</div>
                </div>
                <img className="AdFormatOverviewDetailsReport__image" src={adUnit.icon} />

                <MetricSetTable
                    className="AdFormatOverviewDetailsReport__metric-table"
                    data={convertAdFormatMetricDataToMetricSetData(adUnit, metrics.filter(m => m.showInTable), data)}
                />
            </div>

            <div className="AdFormatOverviewDetailsReportContainer__pointer" style={{ left: pointerPosition }} />
            <div className="AdFormatOverviewDetailsReportContainer__pointer-inner" style={{ left: pointerPosition }} />
        </div>
    ) : null;
}

function convertAdFormatMetricDataToMetricSetData(
    adUnit: AdUnitFormat,
    metrics: MetricInfo[],
    data: ChartDataResponse
): MetricSetData {
    return {
        metricLabels: metrics.map(MetricLabels.tableColumnHeader),
        rows: adUnit.types
            .filter(adt =>
                data.metrics.some(m =>
                    m.data.some(
                        d =>
                            d["dimension-values"].indexOf(adUnit.size) !== -1 &&
                            d["dimension-values"].indexOf(adt.interaction.name) !== -1
                    )
                )
            )
            .map<MetricSetRow>(adType => ({
                title: adType.name,
                metrics: metrics.map(metric => {
                    const metricData = data.metrics.find(m => m.metric === metric.metric);
                    if (!metricData) {
                        return "-";
                    }

                    const value = metricData.data.find(
                        i =>
                            i["dimension-values"].indexOf(adUnit.size) !== -1 &&
                            i["dimension-values"].indexOf(adType.interaction.name) !== -1
                    );

                    if (!value) {
                        return "-";
                    }

                    return metric.isRate
                        ? `${(value["metric-value"] * 100).toFixed(2)}%`
                        : `${formatNumber(value["metric-value"])}`;
                })
            }))
    };
}
